/* tslint:disable */
/* eslint-disable */
/**
 * timereport-service
 * timereport-service
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AccommodationInfoDto } from '../models';
// @ts-ignore
import type { AddToFortnoxPaymentScheduleResult } from '../models';
// @ts-ignore
import type { AddToFortnoxSickListScheduleResult } from '../models';
// @ts-ignore
import type { BookingSupportStatusDto } from '../models';
// @ts-ignore
import type { BookingTotalsResultDto } from '../models';
// @ts-ignore
import type { CloneTimereportInputDto } from '../models';
// @ts-ignore
import type { ConfigurableResultViewDto } from '../models';
// @ts-ignore
import type { ConfigurableResultViewInputDto } from '../models';
// @ts-ignore
import type { ConsultantContractPriceRecordDto } from '../models';
// @ts-ignore
import type { CreateFortnoxInvoiceForBookingResult } from '../models';
// @ts-ignore
import type { CreateInvitationsDto } from '../models';
// @ts-ignore
import type { CreateInvoiceFormInputDto } from '../models';
// @ts-ignore
import type { CreatePayFormInputDto } from '../models';
// @ts-ignore
import type { CreateSickPayFormInputDto } from '../models';
// @ts-ignore
import type { CreateSubcontractorFormInputDto } from '../models';
// @ts-ignore
import type { CreateTimereportInputDto } from '../models';
// @ts-ignore
import type { CustomerContractPriceRecordDto } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { FormErrorResponseDto } from '../models';
// @ts-ignore
import type { InvoiceMonth } from '../models';
// @ts-ignore
import type { InvoiceSplitType } from '../models';
// @ts-ignore
import type { NoteDto } from '../models';
// @ts-ignore
import type { PayFormFields } from '../models';
// @ts-ignore
import type { ProblemDetails } from '../models';
// @ts-ignore
import type { PublishSubcontractorFormResult } from '../models';
// @ts-ignore
import type { SaveTimereportDayResultDto } from '../models';
// @ts-ignore
import type { SickPayFormFields } from '../models';
// @ts-ignore
import type { TimereportDayV2Dto } from '../models';
// @ts-ignore
import type { TimereportDto } from '../models';
// @ts-ignore
import type { TimereportInputDto } from '../models';
// @ts-ignore
import type { TimereportReviewInvitation } from '../models';
// @ts-ignore
import type { TimereportTrackingDto } from '../models';
// @ts-ignore
import type { TimereportV2Dto } from '../models';
// @ts-ignore
import type { TravelInfoDto } from '../models';
// @ts-ignore
import type { ValidateConsultantContractOptionResult } from '../models';
// @ts-ignore
import type { ValidateCustomerContractOptionResult } from '../models';
/**
 * InternalV1Api - axios parameter creator
 * @export
 */
export const InternalV1ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} bookingId 
         * @param {number} [weekDay] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBookingToFortnoxPaymentSchedule: async (bookingId: string, weekDay?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('addBookingToFortnoxPaymentSchedule', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/fortnox/payment-schedule`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (weekDay !== undefined) {
                localVarQueryParameter['weekDay'] = weekDay;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {string} [userEmail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBookingToFortnoxSickSchedule: async (bookingId: string, userEmail?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('addBookingToFortnoxSickSchedule', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/fortnox/sick-schedule`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (userEmail !== undefined) {
                localVarQueryParameter['userEmail'] = userEmail;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {string} [invoiceNumber] 
         * @param {InvoiceMonth} [month] 
         * @param {InvoiceSplitType} [type] 
         * @param {boolean} [force] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appendInvoiceFormToFortnoxInvoice: async (bookingId: string, invoiceNumber?: string, month?: InvoiceMonth, type?: InvoiceSplitType, force?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('appendInvoiceFormToFortnoxInvoice', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/fortnox/invoice-append`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (invoiceNumber !== undefined) {
                localVarQueryParameter['invoiceNumber'] = invoiceNumber;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (force !== undefined) {
                localVarQueryParameter['force'] = force;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {string} [invoiceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appendSubcontractorFormDraftToFortnoxInvocie: async (bookingId: string, invoiceNumber?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('appendSubcontractorFormDraftToFortnoxInvocie', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/fortnox/subcontractor-append`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (invoiceNumber !== undefined) {
                localVarQueryParameter['invoiceNumber'] = invoiceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} timereportId 
         * @param {string} [approvedBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveTimereport: async (timereportId: string, approvedBy?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timereportId' is not null or undefined
            assertParamExists('approveTimereport', 'timereportId', timereportId)
            const localVarPath = `/api/internal/v1/timereports/{timereportId}/approve`
                .replace(`{${"timereportId"}}`, encodeURIComponent(String(timereportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (approvedBy !== undefined) {
                localVarQueryParameter['approvedBy'] = approvedBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [timereportId] 
         * @param {string} [bookingId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignToBooking: async (timereportId?: string, bookingId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/internal/v1/timereports/assignToBooking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timereportId !== undefined) {
                localVarQueryParameter['timereportId'] = timereportId;
            }

            if (bookingId !== undefined) {
                localVarQueryParameter['bookingId'] = bookingId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        broadcastStatusChange: async (start?: string, end?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/internal/v1/maintenance/broadcast-status-change`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        broadcastStatusChangeByBookingIds: async (requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/internal/v1/maintenance/broadcast-status-change-by-bookingIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} timereportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearDaysInternal: async (timereportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timereportId' is not null or undefined
            assertParamExists('clearDaysInternal', 'timereportId', timereportId)
            const localVarPath = `/api/internal/v1/timereports/{timereportId}/clear-days`
                .replace(`{${"timereportId"}}`, encodeURIComponent(String(timereportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {CloneTimereportInputDto} [cloneTimereportInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneTimereport: async (bookingId: string, cloneTimereportInputDto?: CloneTimereportInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('cloneTimereport', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/timereports/booking/{bookingId}/clone`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cloneTimereportInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} timereportId 
         * @param {CreateInvitationsDto} [createInvitationsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvitations: async (timereportId: string, createInvitationsDto?: CreateInvitationsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timereportId' is not null or undefined
            assertParamExists('createInvitations', 'timereportId', timereportId)
            const localVarPath = `/api/internal/v1/review/{timereportId}/createInvitations`
                .replace(`{${"timereportId"}}`, encodeURIComponent(String(timereportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInvitationsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {InvoiceMonth} [month] 
         * @param {InvoiceSplitType} [type] 
         * @param {boolean} [force] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoiceForBooking: async (bookingId: string, month?: InvoiceMonth, type?: InvoiceSplitType, force?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('createInvoiceForBooking', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/fortnox/invoice`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (force !== undefined) {
                localVarQueryParameter['force'] = force;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {CreateInvoiceFormInputDto} [createInvoiceFormInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoiceForm: async (bookingId: string, createInvoiceFormInputDto?: CreateInvoiceFormInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('createInvoiceForm', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/invoice-form/create`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInvoiceFormInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {CreatePayFormInputDto} [createPayFormInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPayForm: async (bookingId: string, createPayFormInputDto?: CreatePayFormInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('createPayForm', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/pay-form/create`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPayFormInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {CreateSickPayFormInputDto} [createSickPayFormInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSickPayForm: async (bookingId: string, createSickPayFormInputDto?: CreateSickPayFormInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('createSickPayForm', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/sick-pay-form/create`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSickPayFormInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {CreateSubcontractorFormInputDto} [createSubcontractorFormInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubcontractorForm: async (bookingId: string, createSubcontractorFormInputDto?: CreateSubcontractorFormInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('createSubcontractorForm', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/subcontractor-form/create`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSubcontractorFormInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateTimereportInputDto} [createTimereportInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTimereportInternal: async (createTimereportInputDto?: CreateTimereportInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/internal/v1/timereports/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTimereportInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInvoiceFormByBookingId: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('deleteInvoiceFormByBookingId', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/invoice-form`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePayFormByBookingId: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('deletePayFormByBookingId', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/pay-form`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSickPayFormByBookingId: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('deleteSickPayFormByBookingId', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/sick-pay-form`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubcontractorFormByBookingId: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('deleteSubcontractorFormByBookingId', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/subcontractor-form`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTimereportByBookingId: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('deleteTimereportByBookingId', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/timereports/booking/{bookingId}`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadConsultantPaymentFormPdfByDate: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('downloadConsultantPaymentFormPdfByDate', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/pay-form/pdf/by-date`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadConsultantPaymentFormPdfByShift: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('downloadConsultantPaymentFormPdfByShift', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/pay-form/pdf/by-shift`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadConsultantPaymentPdf: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('downloadConsultantPaymentPdf', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/pay-form/pdf`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCustomerInvoiceFormPdf: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('downloadCustomerInvoiceFormPdf', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/invoice-form/pdf`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCustomerInvoiceFormPdfByDate: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('downloadCustomerInvoiceFormPdfByDate', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/invoice-form/pdf/by-date`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCustomerInvoiceFormPdfByShift: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('downloadCustomerInvoiceFormPdfByShift', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/invoice-form/pdf/by-shift`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSickPayFormPdf: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('downloadSickPayFormPdf', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/sick-pay-form/pdf`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSickPayFormPdfByDate: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('downloadSickPayFormPdfByDate', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/sick-pay-form/pdf/by-date`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSickPayFormPdfByShift: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('downloadSickPayFormPdfByShift', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/sick-pay-form/pdf/by-shift`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSubcontractorFormDraftPdf: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('downloadSubcontractorFormDraftPdf', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/subcontractor-form/pdf-draft`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSubcontractorFormPdf: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('downloadSubcontractorFormPdf', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/subcontractor-form/pdf`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSubcontractorFormPdfByDate: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('downloadSubcontractorFormPdfByDate', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/subcontractor-form/pdf/by-date`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSubcontractorFormPdfByShift: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('downloadSubcontractorFormPdfByShift', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/subcontractor-form/pdf/by-shift`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSubcontractorFormPdfDraftByDate: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('downloadSubcontractorFormPdfDraftByDate', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/subcontractor-form/pdf-draft/by-date`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSubcontractorPdfDraftByShift: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('downloadSubcontractorPdfDraftByShift', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/subcontractor-form/pdf-draft/by-shift`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {string} [invoiceNumber] 
         * @param {string} [invoiceDate] 
         * @param {string} [supplierNumber] 
         * @param {string} [supplierVatNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSubcontractorSelfInvoicingFormPdf: async (bookingId: string, invoiceNumber?: string, invoiceDate?: string, supplierNumber?: string, supplierVatNumber?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('downloadSubcontractorSelfInvoicingFormPdf', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/subcontractor-form/self-invoicing/pdf`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (invoiceNumber !== undefined) {
                localVarQueryParameter['invoiceNumber'] = invoiceNumber;
            }

            if (invoiceDate !== undefined) {
                localVarQueryParameter['invoiceDate'] = (invoiceDate as any instanceof Date) ?
                    (invoiceDate as any).toISOString() :
                    invoiceDate;
            }

            if (supplierNumber !== undefined) {
                localVarQueryParameter['supplierNumber'] = supplierNumber;
            }

            if (supplierVatNumber !== undefined) {
                localVarQueryParameter['supplierVatNumber'] = supplierVatNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingTotal: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('getBookingTotal', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/bookings/{bookingId}/totals`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByBookingId: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('getByBookingId', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/timereports/booking/{bookingId}`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByBookingIds: async (requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/internal/v1/timereports/getByBookingIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} timereportId 
         * @param {ConfigurableResultViewInputDto} [configurableResultViewInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurableView: async (timereportId: string, configurableResultViewInputDto?: ConfigurableResultViewInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timereportId' is not null or undefined
            assertParamExists('getConfigurableView', 'timereportId', timereportId)
            const localVarPath = `/api/internal/v1/timereports/{timereportId}/configurable-result-view`
                .replace(`{${"timereportId"}}`, encodeURIComponent(String(timereportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configurableResultViewInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {number} dayIndex 
         * @param {number} expensesInd 
         * @param {number} index 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpensesReceipt: async (bookingId: string, dayIndex: number, expensesInd: number, index: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('getExpensesReceipt', 'bookingId', bookingId)
            // verify required parameter 'dayIndex' is not null or undefined
            assertParamExists('getExpensesReceipt', 'dayIndex', dayIndex)
            // verify required parameter 'expensesInd' is not null or undefined
            assertParamExists('getExpensesReceipt', 'expensesInd', expensesInd)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('getExpensesReceipt', 'index', index)
            const localVarPath = `/api/internal/v1/timereports/booking/{bookingId}/days/{dayIndex}/expenses/{expensesInd}/attachment/{index}`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"dayIndex"}}`, encodeURIComponent(String(dayIndex)))
                .replace(`{${"expensesInd"}}`, encodeURIComponent(String(expensesInd)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [consultantId] 
         * @param {number} [week] 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeTimereports: async (consultantId?: string, week?: number, year?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/internal/v1/timereports/getFreeTimereports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (consultantId !== undefined) {
                localVarQueryParameter['consultantId'] = consultantId;
            }

            if (week !== undefined) {
                localVarQueryParameter['week'] = week;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceStatusForBooking: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('getInvoiceStatusForBooking', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/bookings/{bookingId}/status`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayFormForBooking: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('getPayFormForBooking', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/pay-form`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSickPayFormForBooking: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('getSickPayFormForBooking', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/sick-pay-form`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackingInternal: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('getTrackingInternal', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/timereports/{bookingId}/tracking`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processMailTask: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/process-mail-task`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {string} [selfInvoiceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishSubcontractorFormDraftToFortnox: async (bookingId: string, selfInvoiceNumber?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('publishSubcontractorFormDraftToFortnox', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/fortnox/subcontractor`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (selfInvoiceNumber !== undefined) {
                localVarQueryParameter['selfInvoiceNumber'] = selfInvoiceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {NoteDto} [noteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveConsultantPaymentNote: async (bookingId: string, noteDto?: NoteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('saveConsultantPaymentNote', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/timereports/booking/{bookingId}/consultant-payment-note`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(noteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {NoteDto} [noteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveConsultantSickPaymentNote: async (bookingId: string, noteDto?: NoteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('saveConsultantSickPaymentNote', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/timereports/booking/{bookingId}/consultant-sick-payment-note`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(noteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {NoteDto} [noteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCustomerInvoiceNote: async (bookingId: string, noteDto?: NoteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('saveCustomerInvoiceNote', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/timereports/booking/{bookingId}/customer-invoice-note`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(noteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} timereportId 
         * @param {TimereportDayV2Dto} [timereportDayV2Dto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDay: async (timereportId: string, timereportDayV2Dto?: TimereportDayV2Dto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timereportId' is not null or undefined
            assertParamExists('saveDay', 'timereportId', timereportId)
            const localVarPath = `/api/internal/v1/timereports/{timereportId}/days`
                .replace(`{${"timereportId"}}`, encodeURIComponent(String(timereportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(timereportDayV2Dto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {NoteDto} [noteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSubcontractorFormNote: async (bookingId: string, noteDto?: NoteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('saveSubcontractorFormNote', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/timereports/booking/{bookingId}/subcontractor-form-note`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(noteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {Array<AccommodationInfoDto>} accommodationInfoDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAccommodationBenefitTax: async (bookingId: string, accommodationInfoDto: Array<AccommodationInfoDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('setAccommodationBenefitTax', 'bookingId', bookingId)
            // verify required parameter 'accommodationInfoDto' is not null or undefined
            assertParamExists('setAccommodationBenefitTax', 'accommodationInfoDto', accommodationInfoDto)
            const localVarPath = `/api/internal/v1/timereports/booking/{bookingId}/accommodation`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accommodationInfoDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {string} [approvedBy] 
         * @param {string} [approvedId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTimereportDraft: async (bookingId: string, approvedBy?: string, approvedId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('setTimereportDraft', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/timereports/booking/{bookingId}/set-draft`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (approvedBy !== undefined) {
                localVarQueryParameter['approvedBy'] = approvedBy;
            }

            if (approvedId !== undefined) {
                localVarQueryParameter['approvedId'] = approvedId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {Array<TravelInfoDto>} travelInfoDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTravelConfirmation: async (bookingId: string, travelInfoDto: Array<TravelInfoDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('setTravelConfirmation', 'bookingId', bookingId)
            // verify required parameter 'travelInfoDto' is not null or undefined
            assertParamExists('setTravelConfirmation', 'travelInfoDto', travelInfoDto)
            const localVarPath = `/api/internal/v1/timereports/booking/{bookingId}/travel`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(travelInfoDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [timereportId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submittedByConsultantTimereportPipeJob: async (timereportId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/SubmittedByConsultantTimereportPipeJob`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timereportId !== undefined) {
                localVarQueryParameter['timereportId'] = timereportId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submittedByConsultantTimereportsWatcher: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/SubmittedByConsultantTimereportsWatcher`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSyncAllGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/test/sync-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [now] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unconfirmedTimereportNotification: async (now?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/unconfirmed-timereport-notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (now !== undefined) {
                localVarQueryParameter['now'] = (now as any instanceof Date) ?
                    (now as any).toISOString() :
                    now;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {TimereportInputDto} [timereportInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimereportByBookingId: async (bookingId: string, timereportInputDto?: TimereportInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('updateTimereportByBookingId', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/timereports/booking/{bookingId}`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(timereportInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<ConsultantContractPriceRecordDto>} [consultantContractPriceRecordDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateConsultantContractOptions: async (consultantContractPriceRecordDto?: Array<ConsultantContractPriceRecordDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/consultantContract/validateOptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(consultantContractPriceRecordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<CustomerContractPriceRecordDto>} [customerContractPriceRecordDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCustomerContractOptions: async (customerContractPriceRecordDto?: Array<CustomerContractPriceRecordDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/customerContract/validateOptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customerContractPriceRecordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewConsultantPaymentPdf: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('viewConsultantPaymentPdf', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/pay-form/pdf/view`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewCustomerInvoiceFormPdf: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('viewCustomerInvoiceFormPdf', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/invoice-form/pdf/view`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewSickPayFormPdf: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('viewSickPayFormPdf', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/sick-pay-form/pdf/view`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewSubcontractorFormDraftPdf: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('viewSubcontractorFormDraftPdf', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/subcontractor-form/pdf-draft/view`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewSubcontractorFormPdf: async (bookingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('viewSubcontractorFormPdf', 'bookingId', bookingId)
            const localVarPath = `/api/internal/v1/booking/{bookingId}/subcontractor-form/pdf/view`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InternalV1Api - functional programming interface
 * @export
 */
export const InternalV1ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InternalV1ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} bookingId 
         * @param {number} [weekDay] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addBookingToFortnoxPaymentSchedule(bookingId: string, weekDay?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddToFortnoxPaymentScheduleResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addBookingToFortnoxPaymentSchedule(bookingId, weekDay, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.addBookingToFortnoxPaymentSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {string} [userEmail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addBookingToFortnoxSickSchedule(bookingId: string, userEmail?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddToFortnoxSickListScheduleResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addBookingToFortnoxSickSchedule(bookingId, userEmail, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.addBookingToFortnoxSickSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {string} [invoiceNumber] 
         * @param {InvoiceMonth} [month] 
         * @param {InvoiceSplitType} [type] 
         * @param {boolean} [force] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appendInvoiceFormToFortnoxInvoice(bookingId: string, invoiceNumber?: string, month?: InvoiceMonth, type?: InvoiceSplitType, force?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateFortnoxInvoiceForBookingResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appendInvoiceFormToFortnoxInvoice(bookingId, invoiceNumber, month, type, force, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.appendInvoiceFormToFortnoxInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {string} [invoiceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appendSubcontractorFormDraftToFortnoxInvocie(bookingId: string, invoiceNumber?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublishSubcontractorFormResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appendSubcontractorFormDraftToFortnoxInvocie(bookingId, invoiceNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.appendSubcontractorFormDraftToFortnoxInvocie']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} timereportId 
         * @param {string} [approvedBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveTimereport(timereportId: string, approvedBy?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimereportV2Dto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveTimereport(timereportId, approvedBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.approveTimereport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [timereportId] 
         * @param {string} [bookingId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignToBooking(timereportId?: string, bookingId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimereportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignToBooking(timereportId, bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.assignToBooking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async broadcastStatusChange(start?: string, end?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.broadcastStatusChange(start, end, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.broadcastStatusChange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async broadcastStatusChangeByBookingIds(requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.broadcastStatusChangeByBookingIds(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.broadcastStatusChangeByBookingIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} timereportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearDaysInternal(timereportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimereportV2Dto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clearDaysInternal(timereportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.clearDaysInternal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {CloneTimereportInputDto} [cloneTimereportInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cloneTimereport(bookingId: string, cloneTimereportInputDto?: CloneTimereportInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimereportV2Dto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cloneTimereport(bookingId, cloneTimereportInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.cloneTimereport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} timereportId 
         * @param {CreateInvitationsDto} [createInvitationsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInvitations(timereportId: string, createInvitationsDto?: CreateInvitationsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TimereportReviewInvitation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInvitations(timereportId, createInvitationsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.createInvitations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {InvoiceMonth} [month] 
         * @param {InvoiceSplitType} [type] 
         * @param {boolean} [force] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInvoiceForBooking(bookingId: string, month?: InvoiceMonth, type?: InvoiceSplitType, force?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateFortnoxInvoiceForBookingResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInvoiceForBooking(bookingId, month, type, force, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.createInvoiceForBooking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {CreateInvoiceFormInputDto} [createInvoiceFormInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInvoiceForm(bookingId: string, createInvoiceFormInputDto?: CreateInvoiceFormInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInvoiceForm(bookingId, createInvoiceFormInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.createInvoiceForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {CreatePayFormInputDto} [createPayFormInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPayForm(bookingId: string, createPayFormInputDto?: CreatePayFormInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPayForm(bookingId, createPayFormInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.createPayForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {CreateSickPayFormInputDto} [createSickPayFormInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSickPayForm(bookingId: string, createSickPayFormInputDto?: CreateSickPayFormInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSickPayForm(bookingId, createSickPayFormInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.createSickPayForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {CreateSubcontractorFormInputDto} [createSubcontractorFormInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSubcontractorForm(bookingId: string, createSubcontractorFormInputDto?: CreateSubcontractorFormInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSubcontractorForm(bookingId, createSubcontractorFormInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.createSubcontractorForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateTimereportInputDto} [createTimereportInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTimereportInternal(createTimereportInputDto?: CreateTimereportInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimereportV2Dto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTimereportInternal(createTimereportInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.createTimereportInternal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInvoiceFormByBookingId(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInvoiceFormByBookingId(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.deleteInvoiceFormByBookingId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePayFormByBookingId(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePayFormByBookingId(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.deletePayFormByBookingId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSickPayFormByBookingId(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSickPayFormByBookingId(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.deleteSickPayFormByBookingId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSubcontractorFormByBookingId(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSubcontractorFormByBookingId(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.deleteSubcontractorFormByBookingId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTimereportByBookingId(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTimereportByBookingId(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.deleteTimereportByBookingId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadConsultantPaymentFormPdfByDate(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadConsultantPaymentFormPdfByDate(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.downloadConsultantPaymentFormPdfByDate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadConsultantPaymentFormPdfByShift(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadConsultantPaymentFormPdfByShift(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.downloadConsultantPaymentFormPdfByShift']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadConsultantPaymentPdf(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadConsultantPaymentPdf(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.downloadConsultantPaymentPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadCustomerInvoiceFormPdf(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadCustomerInvoiceFormPdf(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.downloadCustomerInvoiceFormPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadCustomerInvoiceFormPdfByDate(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadCustomerInvoiceFormPdfByDate(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.downloadCustomerInvoiceFormPdfByDate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadCustomerInvoiceFormPdfByShift(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadCustomerInvoiceFormPdfByShift(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.downloadCustomerInvoiceFormPdfByShift']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSickPayFormPdf(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSickPayFormPdf(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.downloadSickPayFormPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSickPayFormPdfByDate(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSickPayFormPdfByDate(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.downloadSickPayFormPdfByDate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSickPayFormPdfByShift(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSickPayFormPdfByShift(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.downloadSickPayFormPdfByShift']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSubcontractorFormDraftPdf(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSubcontractorFormDraftPdf(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.downloadSubcontractorFormDraftPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSubcontractorFormPdf(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSubcontractorFormPdf(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.downloadSubcontractorFormPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSubcontractorFormPdfByDate(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSubcontractorFormPdfByDate(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.downloadSubcontractorFormPdfByDate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSubcontractorFormPdfByShift(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSubcontractorFormPdfByShift(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.downloadSubcontractorFormPdfByShift']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSubcontractorFormPdfDraftByDate(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSubcontractorFormPdfDraftByDate(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.downloadSubcontractorFormPdfDraftByDate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSubcontractorPdfDraftByShift(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSubcontractorPdfDraftByShift(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.downloadSubcontractorPdfDraftByShift']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {string} [invoiceNumber] 
         * @param {string} [invoiceDate] 
         * @param {string} [supplierNumber] 
         * @param {string} [supplierVatNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSubcontractorSelfInvoicingFormPdf(bookingId: string, invoiceNumber?: string, invoiceDate?: string, supplierNumber?: string, supplierVatNumber?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSubcontractorSelfInvoicingFormPdf(bookingId, invoiceNumber, invoiceDate, supplierNumber, supplierVatNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.downloadSubcontractorSelfInvoicingFormPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookingTotal(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingTotalsResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookingTotal(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.getBookingTotal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByBookingId(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimereportV2Dto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByBookingId(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.getByBookingId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByBookingIds(requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TimereportV2Dto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByBookingIds(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.getByBookingIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} timereportId 
         * @param {ConfigurableResultViewInputDto} [configurableResultViewInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfigurableView(timereportId: string, configurableResultViewInputDto?: ConfigurableResultViewInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfigurableResultViewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfigurableView(timereportId, configurableResultViewInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.getConfigurableView']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {number} dayIndex 
         * @param {number} expensesInd 
         * @param {number} index 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExpensesReceipt(bookingId: string, dayIndex: number, expensesInd: number, index: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExpensesReceipt(bookingId, dayIndex, expensesInd, index, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.getExpensesReceipt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [consultantId] 
         * @param {number} [week] 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeTimereports(consultantId?: string, week?: number, year?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TimereportDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeTimereports(consultantId, week, year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.getFreeTimereports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoiceStatusForBooking(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingSupportStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoiceStatusForBooking(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.getInvoiceStatusForBooking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPayFormForBooking(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayFormFields>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPayFormForBooking(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.getPayFormForBooking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSickPayFormForBooking(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SickPayFormFields>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSickPayFormForBooking(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.getSickPayFormForBooking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrackingInternal(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimereportTrackingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrackingInternal(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.getTrackingInternal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processMailTask(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processMailTask(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.processMailTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {string} [selfInvoiceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishSubcontractorFormDraftToFortnox(bookingId: string, selfInvoiceNumber?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublishSubcontractorFormResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publishSubcontractorFormDraftToFortnox(bookingId, selfInvoiceNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.publishSubcontractorFormDraftToFortnox']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {NoteDto} [noteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveConsultantPaymentNote(bookingId: string, noteDto?: NoteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveConsultantPaymentNote(bookingId, noteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.saveConsultantPaymentNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {NoteDto} [noteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveConsultantSickPaymentNote(bookingId: string, noteDto?: NoteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveConsultantSickPaymentNote(bookingId, noteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.saveConsultantSickPaymentNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {NoteDto} [noteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCustomerInvoiceNote(bookingId: string, noteDto?: NoteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCustomerInvoiceNote(bookingId, noteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.saveCustomerInvoiceNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} timereportId 
         * @param {TimereportDayV2Dto} [timereportDayV2Dto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveDay(timereportId: string, timereportDayV2Dto?: TimereportDayV2Dto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaveTimereportDayResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveDay(timereportId, timereportDayV2Dto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.saveDay']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {NoteDto} [noteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSubcontractorFormNote(bookingId: string, noteDto?: NoteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSubcontractorFormNote(bookingId, noteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.saveSubcontractorFormNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {Array<AccommodationInfoDto>} accommodationInfoDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAccommodationBenefitTax(bookingId: string, accommodationInfoDto: Array<AccommodationInfoDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAccommodationBenefitTax(bookingId, accommodationInfoDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.setAccommodationBenefitTax']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {string} [approvedBy] 
         * @param {string} [approvedId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setTimereportDraft(bookingId: string, approvedBy?: string, approvedId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimereportV2Dto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setTimereportDraft(bookingId, approvedBy, approvedId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.setTimereportDraft']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {Array<TravelInfoDto>} travelInfoDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setTravelConfirmation(bookingId: string, travelInfoDto: Array<TravelInfoDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setTravelConfirmation(bookingId, travelInfoDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.setTravelConfirmation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [timereportId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submittedByConsultantTimereportPipeJob(timereportId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submittedByConsultantTimereportPipeJob(timereportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.submittedByConsultantTimereportPipeJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submittedByConsultantTimereportsWatcher(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submittedByConsultantTimereportsWatcher(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.submittedByConsultantTimereportsWatcher']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testSyncAllGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testSyncAllGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.testSyncAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [now] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unconfirmedTimereportNotification(now?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unconfirmedTimereportNotification(now, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.unconfirmedTimereportNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {TimereportInputDto} [timereportInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTimereportByBookingId(bookingId: string, timereportInputDto?: TimereportInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimereportV2Dto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTimereportByBookingId(bookingId, timereportInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.updateTimereportByBookingId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<ConsultantContractPriceRecordDto>} [consultantContractPriceRecordDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateConsultantContractOptions(consultantContractPriceRecordDto?: Array<ConsultantContractPriceRecordDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ValidateConsultantContractOptionResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateConsultantContractOptions(consultantContractPriceRecordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.validateConsultantContractOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<CustomerContractPriceRecordDto>} [customerContractPriceRecordDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateCustomerContractOptions(customerContractPriceRecordDto?: Array<CustomerContractPriceRecordDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ValidateCustomerContractOptionResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateCustomerContractOptions(customerContractPriceRecordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.validateCustomerContractOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewConsultantPaymentPdf(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewConsultantPaymentPdf(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.viewConsultantPaymentPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewCustomerInvoiceFormPdf(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewCustomerInvoiceFormPdf(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.viewCustomerInvoiceFormPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewSickPayFormPdf(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewSickPayFormPdf(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.viewSickPayFormPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewSubcontractorFormDraftPdf(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewSubcontractorFormDraftPdf(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.viewSubcontractorFormDraftPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewSubcontractorFormPdf(bookingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewSubcontractorFormPdf(bookingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalV1Api.viewSubcontractorFormPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InternalV1Api - factory interface
 * @export
 */
export const InternalV1ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InternalV1ApiFp(configuration)
    return {
        /**
         * 
         * @param {InternalV1ApiAddBookingToFortnoxPaymentScheduleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBookingToFortnoxPaymentSchedule(requestParameters: InternalV1ApiAddBookingToFortnoxPaymentScheduleRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddToFortnoxPaymentScheduleResult> {
            return localVarFp.addBookingToFortnoxPaymentSchedule(requestParameters.bookingId, requestParameters.weekDay, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiAddBookingToFortnoxSickScheduleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBookingToFortnoxSickSchedule(requestParameters: InternalV1ApiAddBookingToFortnoxSickScheduleRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddToFortnoxSickListScheduleResult> {
            return localVarFp.addBookingToFortnoxSickSchedule(requestParameters.bookingId, requestParameters.userEmail, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiAppendInvoiceFormToFortnoxInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appendInvoiceFormToFortnoxInvoice(requestParameters: InternalV1ApiAppendInvoiceFormToFortnoxInvoiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateFortnoxInvoiceForBookingResult> {
            return localVarFp.appendInvoiceFormToFortnoxInvoice(requestParameters.bookingId, requestParameters.invoiceNumber, requestParameters.month, requestParameters.type, requestParameters.force, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiAppendSubcontractorFormDraftToFortnoxInvocieRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appendSubcontractorFormDraftToFortnoxInvocie(requestParameters: InternalV1ApiAppendSubcontractorFormDraftToFortnoxInvocieRequest, options?: RawAxiosRequestConfig): AxiosPromise<PublishSubcontractorFormResult> {
            return localVarFp.appendSubcontractorFormDraftToFortnoxInvocie(requestParameters.bookingId, requestParameters.invoiceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiApproveTimereportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveTimereport(requestParameters: InternalV1ApiApproveTimereportRequest, options?: RawAxiosRequestConfig): AxiosPromise<TimereportV2Dto> {
            return localVarFp.approveTimereport(requestParameters.timereportId, requestParameters.approvedBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiAssignToBookingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignToBooking(requestParameters: InternalV1ApiAssignToBookingRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TimereportDto> {
            return localVarFp.assignToBooking(requestParameters.timereportId, requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiBroadcastStatusChangeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        broadcastStatusChange(requestParameters: InternalV1ApiBroadcastStatusChangeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.broadcastStatusChange(requestParameters.start, requestParameters.end, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiBroadcastStatusChangeByBookingIdsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        broadcastStatusChangeByBookingIds(requestParameters: InternalV1ApiBroadcastStatusChangeByBookingIdsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.broadcastStatusChangeByBookingIds(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiClearDaysInternalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearDaysInternal(requestParameters: InternalV1ApiClearDaysInternalRequest, options?: RawAxiosRequestConfig): AxiosPromise<TimereportV2Dto> {
            return localVarFp.clearDaysInternal(requestParameters.timereportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiCloneTimereportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneTimereport(requestParameters: InternalV1ApiCloneTimereportRequest, options?: RawAxiosRequestConfig): AxiosPromise<TimereportV2Dto> {
            return localVarFp.cloneTimereport(requestParameters.bookingId, requestParameters.cloneTimereportInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiCreateInvitationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvitations(requestParameters: InternalV1ApiCreateInvitationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TimereportReviewInvitation>> {
            return localVarFp.createInvitations(requestParameters.timereportId, requestParameters.createInvitationsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiCreateInvoiceForBookingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoiceForBooking(requestParameters: InternalV1ApiCreateInvoiceForBookingRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateFortnoxInvoiceForBookingResult> {
            return localVarFp.createInvoiceForBooking(requestParameters.bookingId, requestParameters.month, requestParameters.type, requestParameters.force, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiCreateInvoiceFormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoiceForm(requestParameters: InternalV1ApiCreateInvoiceFormRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createInvoiceForm(requestParameters.bookingId, requestParameters.createInvoiceFormInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiCreatePayFormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPayForm(requestParameters: InternalV1ApiCreatePayFormRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createPayForm(requestParameters.bookingId, requestParameters.createPayFormInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiCreateSickPayFormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSickPayForm(requestParameters: InternalV1ApiCreateSickPayFormRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createSickPayForm(requestParameters.bookingId, requestParameters.createSickPayFormInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiCreateSubcontractorFormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubcontractorForm(requestParameters: InternalV1ApiCreateSubcontractorFormRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createSubcontractorForm(requestParameters.bookingId, requestParameters.createSubcontractorFormInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiCreateTimereportInternalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTimereportInternal(requestParameters: InternalV1ApiCreateTimereportInternalRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TimereportV2Dto> {
            return localVarFp.createTimereportInternal(requestParameters.createTimereportInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiDeleteInvoiceFormByBookingIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInvoiceFormByBookingId(requestParameters: InternalV1ApiDeleteInvoiceFormByBookingIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteInvoiceFormByBookingId(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiDeletePayFormByBookingIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePayFormByBookingId(requestParameters: InternalV1ApiDeletePayFormByBookingIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePayFormByBookingId(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiDeleteSickPayFormByBookingIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSickPayFormByBookingId(requestParameters: InternalV1ApiDeleteSickPayFormByBookingIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSickPayFormByBookingId(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiDeleteSubcontractorFormByBookingIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubcontractorFormByBookingId(requestParameters: InternalV1ApiDeleteSubcontractorFormByBookingIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSubcontractorFormByBookingId(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiDeleteTimereportByBookingIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTimereportByBookingId(requestParameters: InternalV1ApiDeleteTimereportByBookingIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTimereportByBookingId(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiDownloadConsultantPaymentFormPdfByDateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadConsultantPaymentFormPdfByDate(requestParameters: InternalV1ApiDownloadConsultantPaymentFormPdfByDateRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadConsultantPaymentFormPdfByDate(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiDownloadConsultantPaymentFormPdfByShiftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadConsultantPaymentFormPdfByShift(requestParameters: InternalV1ApiDownloadConsultantPaymentFormPdfByShiftRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadConsultantPaymentFormPdfByShift(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiDownloadConsultantPaymentPdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadConsultantPaymentPdf(requestParameters: InternalV1ApiDownloadConsultantPaymentPdfRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadConsultantPaymentPdf(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiDownloadCustomerInvoiceFormPdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCustomerInvoiceFormPdf(requestParameters: InternalV1ApiDownloadCustomerInvoiceFormPdfRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadCustomerInvoiceFormPdf(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiDownloadCustomerInvoiceFormPdfByDateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCustomerInvoiceFormPdfByDate(requestParameters: InternalV1ApiDownloadCustomerInvoiceFormPdfByDateRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadCustomerInvoiceFormPdfByDate(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiDownloadCustomerInvoiceFormPdfByShiftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCustomerInvoiceFormPdfByShift(requestParameters: InternalV1ApiDownloadCustomerInvoiceFormPdfByShiftRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadCustomerInvoiceFormPdfByShift(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiDownloadSickPayFormPdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSickPayFormPdf(requestParameters: InternalV1ApiDownloadSickPayFormPdfRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadSickPayFormPdf(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiDownloadSickPayFormPdfByDateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSickPayFormPdfByDate(requestParameters: InternalV1ApiDownloadSickPayFormPdfByDateRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadSickPayFormPdfByDate(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiDownloadSickPayFormPdfByShiftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSickPayFormPdfByShift(requestParameters: InternalV1ApiDownloadSickPayFormPdfByShiftRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadSickPayFormPdfByShift(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiDownloadSubcontractorFormDraftPdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSubcontractorFormDraftPdf(requestParameters: InternalV1ApiDownloadSubcontractorFormDraftPdfRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadSubcontractorFormDraftPdf(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiDownloadSubcontractorFormPdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSubcontractorFormPdf(requestParameters: InternalV1ApiDownloadSubcontractorFormPdfRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadSubcontractorFormPdf(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiDownloadSubcontractorFormPdfByDateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSubcontractorFormPdfByDate(requestParameters: InternalV1ApiDownloadSubcontractorFormPdfByDateRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadSubcontractorFormPdfByDate(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiDownloadSubcontractorFormPdfByShiftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSubcontractorFormPdfByShift(requestParameters: InternalV1ApiDownloadSubcontractorFormPdfByShiftRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadSubcontractorFormPdfByShift(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiDownloadSubcontractorFormPdfDraftByDateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSubcontractorFormPdfDraftByDate(requestParameters: InternalV1ApiDownloadSubcontractorFormPdfDraftByDateRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadSubcontractorFormPdfDraftByDate(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiDownloadSubcontractorPdfDraftByShiftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSubcontractorPdfDraftByShift(requestParameters: InternalV1ApiDownloadSubcontractorPdfDraftByShiftRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadSubcontractorPdfDraftByShift(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiDownloadSubcontractorSelfInvoicingFormPdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSubcontractorSelfInvoicingFormPdf(requestParameters: InternalV1ApiDownloadSubcontractorSelfInvoicingFormPdfRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadSubcontractorSelfInvoicingFormPdf(requestParameters.bookingId, requestParameters.invoiceNumber, requestParameters.invoiceDate, requestParameters.supplierNumber, requestParameters.supplierVatNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiGetBookingTotalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingTotal(requestParameters: InternalV1ApiGetBookingTotalRequest, options?: RawAxiosRequestConfig): AxiosPromise<BookingTotalsResultDto> {
            return localVarFp.getBookingTotal(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiGetByBookingIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByBookingId(requestParameters: InternalV1ApiGetByBookingIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<TimereportV2Dto> {
            return localVarFp.getByBookingId(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiGetByBookingIdsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByBookingIds(requestParameters: InternalV1ApiGetByBookingIdsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<TimereportV2Dto>> {
            return localVarFp.getByBookingIds(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiGetConfigurableViewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurableView(requestParameters: InternalV1ApiGetConfigurableViewRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConfigurableResultViewDto> {
            return localVarFp.getConfigurableView(requestParameters.timereportId, requestParameters.configurableResultViewInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiGetExpensesReceiptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpensesReceipt(requestParameters: InternalV1ApiGetExpensesReceiptRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getExpensesReceipt(requestParameters.bookingId, requestParameters.dayIndex, requestParameters.expensesInd, requestParameters.index, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiGetFreeTimereportsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeTimereports(requestParameters: InternalV1ApiGetFreeTimereportsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<TimereportDto>> {
            return localVarFp.getFreeTimereports(requestParameters.consultantId, requestParameters.week, requestParameters.year, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiGetInvoiceStatusForBookingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceStatusForBooking(requestParameters: InternalV1ApiGetInvoiceStatusForBookingRequest, options?: RawAxiosRequestConfig): AxiosPromise<BookingSupportStatusDto> {
            return localVarFp.getInvoiceStatusForBooking(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiGetPayFormForBookingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayFormForBooking(requestParameters: InternalV1ApiGetPayFormForBookingRequest, options?: RawAxiosRequestConfig): AxiosPromise<PayFormFields> {
            return localVarFp.getPayFormForBooking(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiGetSickPayFormForBookingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSickPayFormForBooking(requestParameters: InternalV1ApiGetSickPayFormForBookingRequest, options?: RawAxiosRequestConfig): AxiosPromise<SickPayFormFields> {
            return localVarFp.getSickPayFormForBooking(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiGetTrackingInternalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackingInternal(requestParameters: InternalV1ApiGetTrackingInternalRequest, options?: RawAxiosRequestConfig): AxiosPromise<TimereportTrackingDto> {
            return localVarFp.getTrackingInternal(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processMailTask(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.processMailTask(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiPublishSubcontractorFormDraftToFortnoxRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishSubcontractorFormDraftToFortnox(requestParameters: InternalV1ApiPublishSubcontractorFormDraftToFortnoxRequest, options?: RawAxiosRequestConfig): AxiosPromise<PublishSubcontractorFormResult> {
            return localVarFp.publishSubcontractorFormDraftToFortnox(requestParameters.bookingId, requestParameters.selfInvoiceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiSaveConsultantPaymentNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveConsultantPaymentNote(requestParameters: InternalV1ApiSaveConsultantPaymentNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.saveConsultantPaymentNote(requestParameters.bookingId, requestParameters.noteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiSaveConsultantSickPaymentNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveConsultantSickPaymentNote(requestParameters: InternalV1ApiSaveConsultantSickPaymentNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.saveConsultantSickPaymentNote(requestParameters.bookingId, requestParameters.noteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiSaveCustomerInvoiceNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCustomerInvoiceNote(requestParameters: InternalV1ApiSaveCustomerInvoiceNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.saveCustomerInvoiceNote(requestParameters.bookingId, requestParameters.noteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiSaveDayRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDay(requestParameters: InternalV1ApiSaveDayRequest, options?: RawAxiosRequestConfig): AxiosPromise<SaveTimereportDayResultDto> {
            return localVarFp.saveDay(requestParameters.timereportId, requestParameters.timereportDayV2Dto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiSaveSubcontractorFormNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSubcontractorFormNote(requestParameters: InternalV1ApiSaveSubcontractorFormNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.saveSubcontractorFormNote(requestParameters.bookingId, requestParameters.noteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiSetAccommodationBenefitTaxRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAccommodationBenefitTax(requestParameters: InternalV1ApiSetAccommodationBenefitTaxRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setAccommodationBenefitTax(requestParameters.bookingId, requestParameters.accommodationInfoDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiSetTimereportDraftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTimereportDraft(requestParameters: InternalV1ApiSetTimereportDraftRequest, options?: RawAxiosRequestConfig): AxiosPromise<TimereportV2Dto> {
            return localVarFp.setTimereportDraft(requestParameters.bookingId, requestParameters.approvedBy, requestParameters.approvedId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiSetTravelConfirmationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTravelConfirmation(requestParameters: InternalV1ApiSetTravelConfirmationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setTravelConfirmation(requestParameters.bookingId, requestParameters.travelInfoDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiSubmittedByConsultantTimereportPipeJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submittedByConsultantTimereportPipeJob(requestParameters: InternalV1ApiSubmittedByConsultantTimereportPipeJobRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.submittedByConsultantTimereportPipeJob(requestParameters.timereportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submittedByConsultantTimereportsWatcher(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.submittedByConsultantTimereportsWatcher(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSyncAllGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.testSyncAllGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiUnconfirmedTimereportNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unconfirmedTimereportNotification(requestParameters: InternalV1ApiUnconfirmedTimereportNotificationRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unconfirmedTimereportNotification(requestParameters.now, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiUpdateTimereportByBookingIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimereportByBookingId(requestParameters: InternalV1ApiUpdateTimereportByBookingIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<TimereportV2Dto> {
            return localVarFp.updateTimereportByBookingId(requestParameters.bookingId, requestParameters.timereportInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiValidateConsultantContractOptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateConsultantContractOptions(requestParameters: InternalV1ApiValidateConsultantContractOptionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ValidateConsultantContractOptionResult>> {
            return localVarFp.validateConsultantContractOptions(requestParameters.consultantContractPriceRecordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiValidateCustomerContractOptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCustomerContractOptions(requestParameters: InternalV1ApiValidateCustomerContractOptionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ValidateCustomerContractOptionResult>> {
            return localVarFp.validateCustomerContractOptions(requestParameters.customerContractPriceRecordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiViewConsultantPaymentPdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewConsultantPaymentPdf(requestParameters: InternalV1ApiViewConsultantPaymentPdfRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.viewConsultantPaymentPdf(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiViewCustomerInvoiceFormPdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewCustomerInvoiceFormPdf(requestParameters: InternalV1ApiViewCustomerInvoiceFormPdfRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.viewCustomerInvoiceFormPdf(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiViewSickPayFormPdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewSickPayFormPdf(requestParameters: InternalV1ApiViewSickPayFormPdfRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.viewSickPayFormPdf(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiViewSubcontractorFormDraftPdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewSubcontractorFormDraftPdf(requestParameters: InternalV1ApiViewSubcontractorFormDraftPdfRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.viewSubcontractorFormDraftPdf(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalV1ApiViewSubcontractorFormPdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewSubcontractorFormPdf(requestParameters: InternalV1ApiViewSubcontractorFormPdfRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.viewSubcontractorFormPdf(requestParameters.bookingId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addBookingToFortnoxPaymentSchedule operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiAddBookingToFortnoxPaymentScheduleRequest
 */
export interface InternalV1ApiAddBookingToFortnoxPaymentScheduleRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiAddBookingToFortnoxPaymentSchedule
     */
    readonly bookingId: string

    /**
     * 
     * @type {number}
     * @memberof InternalV1ApiAddBookingToFortnoxPaymentSchedule
     */
    readonly weekDay?: number
}

/**
 * Request parameters for addBookingToFortnoxSickSchedule operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiAddBookingToFortnoxSickScheduleRequest
 */
export interface InternalV1ApiAddBookingToFortnoxSickScheduleRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiAddBookingToFortnoxSickSchedule
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiAddBookingToFortnoxSickSchedule
     */
    readonly userEmail?: string
}

/**
 * Request parameters for appendInvoiceFormToFortnoxInvoice operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiAppendInvoiceFormToFortnoxInvoiceRequest
 */
export interface InternalV1ApiAppendInvoiceFormToFortnoxInvoiceRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiAppendInvoiceFormToFortnoxInvoice
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiAppendInvoiceFormToFortnoxInvoice
     */
    readonly invoiceNumber?: string

    /**
     * 
     * @type {InvoiceMonth}
     * @memberof InternalV1ApiAppendInvoiceFormToFortnoxInvoice
     */
    readonly month?: InvoiceMonth

    /**
     * 
     * @type {InvoiceSplitType}
     * @memberof InternalV1ApiAppendInvoiceFormToFortnoxInvoice
     */
    readonly type?: InvoiceSplitType

    /**
     * 
     * @type {boolean}
     * @memberof InternalV1ApiAppendInvoiceFormToFortnoxInvoice
     */
    readonly force?: boolean
}

/**
 * Request parameters for appendSubcontractorFormDraftToFortnoxInvocie operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiAppendSubcontractorFormDraftToFortnoxInvocieRequest
 */
export interface InternalV1ApiAppendSubcontractorFormDraftToFortnoxInvocieRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiAppendSubcontractorFormDraftToFortnoxInvocie
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiAppendSubcontractorFormDraftToFortnoxInvocie
     */
    readonly invoiceNumber?: string
}

/**
 * Request parameters for approveTimereport operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiApproveTimereportRequest
 */
export interface InternalV1ApiApproveTimereportRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiApproveTimereport
     */
    readonly timereportId: string

    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiApproveTimereport
     */
    readonly approvedBy?: string
}

/**
 * Request parameters for assignToBooking operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiAssignToBookingRequest
 */
export interface InternalV1ApiAssignToBookingRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiAssignToBooking
     */
    readonly timereportId?: string

    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiAssignToBooking
     */
    readonly bookingId?: string
}

/**
 * Request parameters for broadcastStatusChange operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiBroadcastStatusChangeRequest
 */
export interface InternalV1ApiBroadcastStatusChangeRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiBroadcastStatusChange
     */
    readonly start?: string

    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiBroadcastStatusChange
     */
    readonly end?: string
}

/**
 * Request parameters for broadcastStatusChangeByBookingIds operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiBroadcastStatusChangeByBookingIdsRequest
 */
export interface InternalV1ApiBroadcastStatusChangeByBookingIdsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalV1ApiBroadcastStatusChangeByBookingIds
     */
    readonly requestBody?: Array<string>
}

/**
 * Request parameters for clearDaysInternal operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiClearDaysInternalRequest
 */
export interface InternalV1ApiClearDaysInternalRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiClearDaysInternal
     */
    readonly timereportId: string
}

/**
 * Request parameters for cloneTimereport operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiCloneTimereportRequest
 */
export interface InternalV1ApiCloneTimereportRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiCloneTimereport
     */
    readonly bookingId: string

    /**
     * 
     * @type {CloneTimereportInputDto}
     * @memberof InternalV1ApiCloneTimereport
     */
    readonly cloneTimereportInputDto?: CloneTimereportInputDto
}

/**
 * Request parameters for createInvitations operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiCreateInvitationsRequest
 */
export interface InternalV1ApiCreateInvitationsRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiCreateInvitations
     */
    readonly timereportId: string

    /**
     * 
     * @type {CreateInvitationsDto}
     * @memberof InternalV1ApiCreateInvitations
     */
    readonly createInvitationsDto?: CreateInvitationsDto
}

/**
 * Request parameters for createInvoiceForBooking operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiCreateInvoiceForBookingRequest
 */
export interface InternalV1ApiCreateInvoiceForBookingRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiCreateInvoiceForBooking
     */
    readonly bookingId: string

    /**
     * 
     * @type {InvoiceMonth}
     * @memberof InternalV1ApiCreateInvoiceForBooking
     */
    readonly month?: InvoiceMonth

    /**
     * 
     * @type {InvoiceSplitType}
     * @memberof InternalV1ApiCreateInvoiceForBooking
     */
    readonly type?: InvoiceSplitType

    /**
     * 
     * @type {boolean}
     * @memberof InternalV1ApiCreateInvoiceForBooking
     */
    readonly force?: boolean
}

/**
 * Request parameters for createInvoiceForm operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiCreateInvoiceFormRequest
 */
export interface InternalV1ApiCreateInvoiceFormRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiCreateInvoiceForm
     */
    readonly bookingId: string

    /**
     * 
     * @type {CreateInvoiceFormInputDto}
     * @memberof InternalV1ApiCreateInvoiceForm
     */
    readonly createInvoiceFormInputDto?: CreateInvoiceFormInputDto
}

/**
 * Request parameters for createPayForm operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiCreatePayFormRequest
 */
export interface InternalV1ApiCreatePayFormRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiCreatePayForm
     */
    readonly bookingId: string

    /**
     * 
     * @type {CreatePayFormInputDto}
     * @memberof InternalV1ApiCreatePayForm
     */
    readonly createPayFormInputDto?: CreatePayFormInputDto
}

/**
 * Request parameters for createSickPayForm operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiCreateSickPayFormRequest
 */
export interface InternalV1ApiCreateSickPayFormRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiCreateSickPayForm
     */
    readonly bookingId: string

    /**
     * 
     * @type {CreateSickPayFormInputDto}
     * @memberof InternalV1ApiCreateSickPayForm
     */
    readonly createSickPayFormInputDto?: CreateSickPayFormInputDto
}

/**
 * Request parameters for createSubcontractorForm operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiCreateSubcontractorFormRequest
 */
export interface InternalV1ApiCreateSubcontractorFormRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiCreateSubcontractorForm
     */
    readonly bookingId: string

    /**
     * 
     * @type {CreateSubcontractorFormInputDto}
     * @memberof InternalV1ApiCreateSubcontractorForm
     */
    readonly createSubcontractorFormInputDto?: CreateSubcontractorFormInputDto
}

/**
 * Request parameters for createTimereportInternal operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiCreateTimereportInternalRequest
 */
export interface InternalV1ApiCreateTimereportInternalRequest {
    /**
     * 
     * @type {CreateTimereportInputDto}
     * @memberof InternalV1ApiCreateTimereportInternal
     */
    readonly createTimereportInputDto?: CreateTimereportInputDto
}

/**
 * Request parameters for deleteInvoiceFormByBookingId operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiDeleteInvoiceFormByBookingIdRequest
 */
export interface InternalV1ApiDeleteInvoiceFormByBookingIdRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiDeleteInvoiceFormByBookingId
     */
    readonly bookingId: string
}

/**
 * Request parameters for deletePayFormByBookingId operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiDeletePayFormByBookingIdRequest
 */
export interface InternalV1ApiDeletePayFormByBookingIdRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiDeletePayFormByBookingId
     */
    readonly bookingId: string
}

/**
 * Request parameters for deleteSickPayFormByBookingId operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiDeleteSickPayFormByBookingIdRequest
 */
export interface InternalV1ApiDeleteSickPayFormByBookingIdRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiDeleteSickPayFormByBookingId
     */
    readonly bookingId: string
}

/**
 * Request parameters for deleteSubcontractorFormByBookingId operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiDeleteSubcontractorFormByBookingIdRequest
 */
export interface InternalV1ApiDeleteSubcontractorFormByBookingIdRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiDeleteSubcontractorFormByBookingId
     */
    readonly bookingId: string
}

/**
 * Request parameters for deleteTimereportByBookingId operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiDeleteTimereportByBookingIdRequest
 */
export interface InternalV1ApiDeleteTimereportByBookingIdRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiDeleteTimereportByBookingId
     */
    readonly bookingId: string
}

/**
 * Request parameters for downloadConsultantPaymentFormPdfByDate operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiDownloadConsultantPaymentFormPdfByDateRequest
 */
export interface InternalV1ApiDownloadConsultantPaymentFormPdfByDateRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiDownloadConsultantPaymentFormPdfByDate
     */
    readonly bookingId: string
}

/**
 * Request parameters for downloadConsultantPaymentFormPdfByShift operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiDownloadConsultantPaymentFormPdfByShiftRequest
 */
export interface InternalV1ApiDownloadConsultantPaymentFormPdfByShiftRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiDownloadConsultantPaymentFormPdfByShift
     */
    readonly bookingId: string
}

/**
 * Request parameters for downloadConsultantPaymentPdf operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiDownloadConsultantPaymentPdfRequest
 */
export interface InternalV1ApiDownloadConsultantPaymentPdfRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiDownloadConsultantPaymentPdf
     */
    readonly bookingId: string
}

/**
 * Request parameters for downloadCustomerInvoiceFormPdf operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiDownloadCustomerInvoiceFormPdfRequest
 */
export interface InternalV1ApiDownloadCustomerInvoiceFormPdfRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiDownloadCustomerInvoiceFormPdf
     */
    readonly bookingId: string
}

/**
 * Request parameters for downloadCustomerInvoiceFormPdfByDate operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiDownloadCustomerInvoiceFormPdfByDateRequest
 */
export interface InternalV1ApiDownloadCustomerInvoiceFormPdfByDateRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiDownloadCustomerInvoiceFormPdfByDate
     */
    readonly bookingId: string
}

/**
 * Request parameters for downloadCustomerInvoiceFormPdfByShift operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiDownloadCustomerInvoiceFormPdfByShiftRequest
 */
export interface InternalV1ApiDownloadCustomerInvoiceFormPdfByShiftRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiDownloadCustomerInvoiceFormPdfByShift
     */
    readonly bookingId: string
}

/**
 * Request parameters for downloadSickPayFormPdf operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiDownloadSickPayFormPdfRequest
 */
export interface InternalV1ApiDownloadSickPayFormPdfRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiDownloadSickPayFormPdf
     */
    readonly bookingId: string
}

/**
 * Request parameters for downloadSickPayFormPdfByDate operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiDownloadSickPayFormPdfByDateRequest
 */
export interface InternalV1ApiDownloadSickPayFormPdfByDateRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiDownloadSickPayFormPdfByDate
     */
    readonly bookingId: string
}

/**
 * Request parameters for downloadSickPayFormPdfByShift operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiDownloadSickPayFormPdfByShiftRequest
 */
export interface InternalV1ApiDownloadSickPayFormPdfByShiftRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiDownloadSickPayFormPdfByShift
     */
    readonly bookingId: string
}

/**
 * Request parameters for downloadSubcontractorFormDraftPdf operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiDownloadSubcontractorFormDraftPdfRequest
 */
export interface InternalV1ApiDownloadSubcontractorFormDraftPdfRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiDownloadSubcontractorFormDraftPdf
     */
    readonly bookingId: string
}

/**
 * Request parameters for downloadSubcontractorFormPdf operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiDownloadSubcontractorFormPdfRequest
 */
export interface InternalV1ApiDownloadSubcontractorFormPdfRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiDownloadSubcontractorFormPdf
     */
    readonly bookingId: string
}

/**
 * Request parameters for downloadSubcontractorFormPdfByDate operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiDownloadSubcontractorFormPdfByDateRequest
 */
export interface InternalV1ApiDownloadSubcontractorFormPdfByDateRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiDownloadSubcontractorFormPdfByDate
     */
    readonly bookingId: string
}

/**
 * Request parameters for downloadSubcontractorFormPdfByShift operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiDownloadSubcontractorFormPdfByShiftRequest
 */
export interface InternalV1ApiDownloadSubcontractorFormPdfByShiftRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiDownloadSubcontractorFormPdfByShift
     */
    readonly bookingId: string
}

/**
 * Request parameters for downloadSubcontractorFormPdfDraftByDate operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiDownloadSubcontractorFormPdfDraftByDateRequest
 */
export interface InternalV1ApiDownloadSubcontractorFormPdfDraftByDateRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiDownloadSubcontractorFormPdfDraftByDate
     */
    readonly bookingId: string
}

/**
 * Request parameters for downloadSubcontractorPdfDraftByShift operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiDownloadSubcontractorPdfDraftByShiftRequest
 */
export interface InternalV1ApiDownloadSubcontractorPdfDraftByShiftRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiDownloadSubcontractorPdfDraftByShift
     */
    readonly bookingId: string
}

/**
 * Request parameters for downloadSubcontractorSelfInvoicingFormPdf operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiDownloadSubcontractorSelfInvoicingFormPdfRequest
 */
export interface InternalV1ApiDownloadSubcontractorSelfInvoicingFormPdfRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiDownloadSubcontractorSelfInvoicingFormPdf
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiDownloadSubcontractorSelfInvoicingFormPdf
     */
    readonly invoiceNumber?: string

    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiDownloadSubcontractorSelfInvoicingFormPdf
     */
    readonly invoiceDate?: string

    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiDownloadSubcontractorSelfInvoicingFormPdf
     */
    readonly supplierNumber?: string

    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiDownloadSubcontractorSelfInvoicingFormPdf
     */
    readonly supplierVatNumber?: string
}

/**
 * Request parameters for getBookingTotal operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiGetBookingTotalRequest
 */
export interface InternalV1ApiGetBookingTotalRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiGetBookingTotal
     */
    readonly bookingId: string
}

/**
 * Request parameters for getByBookingId operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiGetByBookingIdRequest
 */
export interface InternalV1ApiGetByBookingIdRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiGetByBookingId
     */
    readonly bookingId: string
}

/**
 * Request parameters for getByBookingIds operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiGetByBookingIdsRequest
 */
export interface InternalV1ApiGetByBookingIdsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalV1ApiGetByBookingIds
     */
    readonly requestBody?: Array<string>
}

/**
 * Request parameters for getConfigurableView operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiGetConfigurableViewRequest
 */
export interface InternalV1ApiGetConfigurableViewRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiGetConfigurableView
     */
    readonly timereportId: string

    /**
     * 
     * @type {ConfigurableResultViewInputDto}
     * @memberof InternalV1ApiGetConfigurableView
     */
    readonly configurableResultViewInputDto?: ConfigurableResultViewInputDto
}

/**
 * Request parameters for getExpensesReceipt operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiGetExpensesReceiptRequest
 */
export interface InternalV1ApiGetExpensesReceiptRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiGetExpensesReceipt
     */
    readonly bookingId: string

    /**
     * 
     * @type {number}
     * @memberof InternalV1ApiGetExpensesReceipt
     */
    readonly dayIndex: number

    /**
     * 
     * @type {number}
     * @memberof InternalV1ApiGetExpensesReceipt
     */
    readonly expensesInd: number

    /**
     * 
     * @type {number}
     * @memberof InternalV1ApiGetExpensesReceipt
     */
    readonly index: number
}

/**
 * Request parameters for getFreeTimereports operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiGetFreeTimereportsRequest
 */
export interface InternalV1ApiGetFreeTimereportsRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiGetFreeTimereports
     */
    readonly consultantId?: string

    /**
     * 
     * @type {number}
     * @memberof InternalV1ApiGetFreeTimereports
     */
    readonly week?: number

    /**
     * 
     * @type {number}
     * @memberof InternalV1ApiGetFreeTimereports
     */
    readonly year?: number
}

/**
 * Request parameters for getInvoiceStatusForBooking operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiGetInvoiceStatusForBookingRequest
 */
export interface InternalV1ApiGetInvoiceStatusForBookingRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiGetInvoiceStatusForBooking
     */
    readonly bookingId: string
}

/**
 * Request parameters for getPayFormForBooking operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiGetPayFormForBookingRequest
 */
export interface InternalV1ApiGetPayFormForBookingRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiGetPayFormForBooking
     */
    readonly bookingId: string
}

/**
 * Request parameters for getSickPayFormForBooking operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiGetSickPayFormForBookingRequest
 */
export interface InternalV1ApiGetSickPayFormForBookingRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiGetSickPayFormForBooking
     */
    readonly bookingId: string
}

/**
 * Request parameters for getTrackingInternal operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiGetTrackingInternalRequest
 */
export interface InternalV1ApiGetTrackingInternalRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiGetTrackingInternal
     */
    readonly bookingId: string
}

/**
 * Request parameters for publishSubcontractorFormDraftToFortnox operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiPublishSubcontractorFormDraftToFortnoxRequest
 */
export interface InternalV1ApiPublishSubcontractorFormDraftToFortnoxRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiPublishSubcontractorFormDraftToFortnox
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiPublishSubcontractorFormDraftToFortnox
     */
    readonly selfInvoiceNumber?: string
}

/**
 * Request parameters for saveConsultantPaymentNote operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiSaveConsultantPaymentNoteRequest
 */
export interface InternalV1ApiSaveConsultantPaymentNoteRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiSaveConsultantPaymentNote
     */
    readonly bookingId: string

    /**
     * 
     * @type {NoteDto}
     * @memberof InternalV1ApiSaveConsultantPaymentNote
     */
    readonly noteDto?: NoteDto
}

/**
 * Request parameters for saveConsultantSickPaymentNote operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiSaveConsultantSickPaymentNoteRequest
 */
export interface InternalV1ApiSaveConsultantSickPaymentNoteRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiSaveConsultantSickPaymentNote
     */
    readonly bookingId: string

    /**
     * 
     * @type {NoteDto}
     * @memberof InternalV1ApiSaveConsultantSickPaymentNote
     */
    readonly noteDto?: NoteDto
}

/**
 * Request parameters for saveCustomerInvoiceNote operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiSaveCustomerInvoiceNoteRequest
 */
export interface InternalV1ApiSaveCustomerInvoiceNoteRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiSaveCustomerInvoiceNote
     */
    readonly bookingId: string

    /**
     * 
     * @type {NoteDto}
     * @memberof InternalV1ApiSaveCustomerInvoiceNote
     */
    readonly noteDto?: NoteDto
}

/**
 * Request parameters for saveDay operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiSaveDayRequest
 */
export interface InternalV1ApiSaveDayRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiSaveDay
     */
    readonly timereportId: string

    /**
     * 
     * @type {TimereportDayV2Dto}
     * @memberof InternalV1ApiSaveDay
     */
    readonly timereportDayV2Dto?: TimereportDayV2Dto
}

/**
 * Request parameters for saveSubcontractorFormNote operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiSaveSubcontractorFormNoteRequest
 */
export interface InternalV1ApiSaveSubcontractorFormNoteRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiSaveSubcontractorFormNote
     */
    readonly bookingId: string

    /**
     * 
     * @type {NoteDto}
     * @memberof InternalV1ApiSaveSubcontractorFormNote
     */
    readonly noteDto?: NoteDto
}

/**
 * Request parameters for setAccommodationBenefitTax operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiSetAccommodationBenefitTaxRequest
 */
export interface InternalV1ApiSetAccommodationBenefitTaxRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiSetAccommodationBenefitTax
     */
    readonly bookingId: string

    /**
     * 
     * @type {Array<AccommodationInfoDto>}
     * @memberof InternalV1ApiSetAccommodationBenefitTax
     */
    readonly accommodationInfoDto: Array<AccommodationInfoDto>
}

/**
 * Request parameters for setTimereportDraft operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiSetTimereportDraftRequest
 */
export interface InternalV1ApiSetTimereportDraftRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiSetTimereportDraft
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiSetTimereportDraft
     */
    readonly approvedBy?: string

    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiSetTimereportDraft
     */
    readonly approvedId?: string
}

/**
 * Request parameters for setTravelConfirmation operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiSetTravelConfirmationRequest
 */
export interface InternalV1ApiSetTravelConfirmationRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiSetTravelConfirmation
     */
    readonly bookingId: string

    /**
     * 
     * @type {Array<TravelInfoDto>}
     * @memberof InternalV1ApiSetTravelConfirmation
     */
    readonly travelInfoDto: Array<TravelInfoDto>
}

/**
 * Request parameters for submittedByConsultantTimereportPipeJob operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiSubmittedByConsultantTimereportPipeJobRequest
 */
export interface InternalV1ApiSubmittedByConsultantTimereportPipeJobRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiSubmittedByConsultantTimereportPipeJob
     */
    readonly timereportId?: string
}

/**
 * Request parameters for unconfirmedTimereportNotification operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiUnconfirmedTimereportNotificationRequest
 */
export interface InternalV1ApiUnconfirmedTimereportNotificationRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiUnconfirmedTimereportNotification
     */
    readonly now?: string
}

/**
 * Request parameters for updateTimereportByBookingId operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiUpdateTimereportByBookingIdRequest
 */
export interface InternalV1ApiUpdateTimereportByBookingIdRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiUpdateTimereportByBookingId
     */
    readonly bookingId: string

    /**
     * 
     * @type {TimereportInputDto}
     * @memberof InternalV1ApiUpdateTimereportByBookingId
     */
    readonly timereportInputDto?: TimereportInputDto
}

/**
 * Request parameters for validateConsultantContractOptions operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiValidateConsultantContractOptionsRequest
 */
export interface InternalV1ApiValidateConsultantContractOptionsRequest {
    /**
     * 
     * @type {Array<ConsultantContractPriceRecordDto>}
     * @memberof InternalV1ApiValidateConsultantContractOptions
     */
    readonly consultantContractPriceRecordDto?: Array<ConsultantContractPriceRecordDto>
}

/**
 * Request parameters for validateCustomerContractOptions operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiValidateCustomerContractOptionsRequest
 */
export interface InternalV1ApiValidateCustomerContractOptionsRequest {
    /**
     * 
     * @type {Array<CustomerContractPriceRecordDto>}
     * @memberof InternalV1ApiValidateCustomerContractOptions
     */
    readonly customerContractPriceRecordDto?: Array<CustomerContractPriceRecordDto>
}

/**
 * Request parameters for viewConsultantPaymentPdf operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiViewConsultantPaymentPdfRequest
 */
export interface InternalV1ApiViewConsultantPaymentPdfRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiViewConsultantPaymentPdf
     */
    readonly bookingId: string
}

/**
 * Request parameters for viewCustomerInvoiceFormPdf operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiViewCustomerInvoiceFormPdfRequest
 */
export interface InternalV1ApiViewCustomerInvoiceFormPdfRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiViewCustomerInvoiceFormPdf
     */
    readonly bookingId: string
}

/**
 * Request parameters for viewSickPayFormPdf operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiViewSickPayFormPdfRequest
 */
export interface InternalV1ApiViewSickPayFormPdfRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiViewSickPayFormPdf
     */
    readonly bookingId: string
}

/**
 * Request parameters for viewSubcontractorFormDraftPdf operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiViewSubcontractorFormDraftPdfRequest
 */
export interface InternalV1ApiViewSubcontractorFormDraftPdfRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiViewSubcontractorFormDraftPdf
     */
    readonly bookingId: string
}

/**
 * Request parameters for viewSubcontractorFormPdf operation in InternalV1Api.
 * @export
 * @interface InternalV1ApiViewSubcontractorFormPdfRequest
 */
export interface InternalV1ApiViewSubcontractorFormPdfRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalV1ApiViewSubcontractorFormPdf
     */
    readonly bookingId: string
}

/**
 * InternalV1Api - object-oriented interface
 * @export
 * @class InternalV1Api
 * @extends {BaseAPI}
 */
export class InternalV1Api extends BaseAPI {
    /**
     * 
     * @param {InternalV1ApiAddBookingToFortnoxPaymentScheduleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public addBookingToFortnoxPaymentSchedule(requestParameters: InternalV1ApiAddBookingToFortnoxPaymentScheduleRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).addBookingToFortnoxPaymentSchedule(requestParameters.bookingId, requestParameters.weekDay, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiAddBookingToFortnoxSickScheduleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public addBookingToFortnoxSickSchedule(requestParameters: InternalV1ApiAddBookingToFortnoxSickScheduleRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).addBookingToFortnoxSickSchedule(requestParameters.bookingId, requestParameters.userEmail, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiAppendInvoiceFormToFortnoxInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public appendInvoiceFormToFortnoxInvoice(requestParameters: InternalV1ApiAppendInvoiceFormToFortnoxInvoiceRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).appendInvoiceFormToFortnoxInvoice(requestParameters.bookingId, requestParameters.invoiceNumber, requestParameters.month, requestParameters.type, requestParameters.force, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiAppendSubcontractorFormDraftToFortnoxInvocieRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public appendSubcontractorFormDraftToFortnoxInvocie(requestParameters: InternalV1ApiAppendSubcontractorFormDraftToFortnoxInvocieRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).appendSubcontractorFormDraftToFortnoxInvocie(requestParameters.bookingId, requestParameters.invoiceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiApproveTimereportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public approveTimereport(requestParameters: InternalV1ApiApproveTimereportRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).approveTimereport(requestParameters.timereportId, requestParameters.approvedBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiAssignToBookingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public assignToBooking(requestParameters: InternalV1ApiAssignToBookingRequest = {}, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).assignToBooking(requestParameters.timereportId, requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiBroadcastStatusChangeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public broadcastStatusChange(requestParameters: InternalV1ApiBroadcastStatusChangeRequest = {}, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).broadcastStatusChange(requestParameters.start, requestParameters.end, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiBroadcastStatusChangeByBookingIdsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public broadcastStatusChangeByBookingIds(requestParameters: InternalV1ApiBroadcastStatusChangeByBookingIdsRequest = {}, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).broadcastStatusChangeByBookingIds(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiClearDaysInternalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public clearDaysInternal(requestParameters: InternalV1ApiClearDaysInternalRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).clearDaysInternal(requestParameters.timereportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiCloneTimereportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public cloneTimereport(requestParameters: InternalV1ApiCloneTimereportRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).cloneTimereport(requestParameters.bookingId, requestParameters.cloneTimereportInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiCreateInvitationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public createInvitations(requestParameters: InternalV1ApiCreateInvitationsRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).createInvitations(requestParameters.timereportId, requestParameters.createInvitationsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiCreateInvoiceForBookingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public createInvoiceForBooking(requestParameters: InternalV1ApiCreateInvoiceForBookingRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).createInvoiceForBooking(requestParameters.bookingId, requestParameters.month, requestParameters.type, requestParameters.force, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiCreateInvoiceFormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public createInvoiceForm(requestParameters: InternalV1ApiCreateInvoiceFormRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).createInvoiceForm(requestParameters.bookingId, requestParameters.createInvoiceFormInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiCreatePayFormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public createPayForm(requestParameters: InternalV1ApiCreatePayFormRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).createPayForm(requestParameters.bookingId, requestParameters.createPayFormInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiCreateSickPayFormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public createSickPayForm(requestParameters: InternalV1ApiCreateSickPayFormRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).createSickPayForm(requestParameters.bookingId, requestParameters.createSickPayFormInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiCreateSubcontractorFormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public createSubcontractorForm(requestParameters: InternalV1ApiCreateSubcontractorFormRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).createSubcontractorForm(requestParameters.bookingId, requestParameters.createSubcontractorFormInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiCreateTimereportInternalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public createTimereportInternal(requestParameters: InternalV1ApiCreateTimereportInternalRequest = {}, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).createTimereportInternal(requestParameters.createTimereportInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiDeleteInvoiceFormByBookingIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public deleteInvoiceFormByBookingId(requestParameters: InternalV1ApiDeleteInvoiceFormByBookingIdRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).deleteInvoiceFormByBookingId(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiDeletePayFormByBookingIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public deletePayFormByBookingId(requestParameters: InternalV1ApiDeletePayFormByBookingIdRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).deletePayFormByBookingId(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiDeleteSickPayFormByBookingIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public deleteSickPayFormByBookingId(requestParameters: InternalV1ApiDeleteSickPayFormByBookingIdRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).deleteSickPayFormByBookingId(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiDeleteSubcontractorFormByBookingIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public deleteSubcontractorFormByBookingId(requestParameters: InternalV1ApiDeleteSubcontractorFormByBookingIdRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).deleteSubcontractorFormByBookingId(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiDeleteTimereportByBookingIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public deleteTimereportByBookingId(requestParameters: InternalV1ApiDeleteTimereportByBookingIdRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).deleteTimereportByBookingId(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiDownloadConsultantPaymentFormPdfByDateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public downloadConsultantPaymentFormPdfByDate(requestParameters: InternalV1ApiDownloadConsultantPaymentFormPdfByDateRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).downloadConsultantPaymentFormPdfByDate(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiDownloadConsultantPaymentFormPdfByShiftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public downloadConsultantPaymentFormPdfByShift(requestParameters: InternalV1ApiDownloadConsultantPaymentFormPdfByShiftRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).downloadConsultantPaymentFormPdfByShift(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiDownloadConsultantPaymentPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public downloadConsultantPaymentPdf(requestParameters: InternalV1ApiDownloadConsultantPaymentPdfRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).downloadConsultantPaymentPdf(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiDownloadCustomerInvoiceFormPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public downloadCustomerInvoiceFormPdf(requestParameters: InternalV1ApiDownloadCustomerInvoiceFormPdfRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).downloadCustomerInvoiceFormPdf(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiDownloadCustomerInvoiceFormPdfByDateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public downloadCustomerInvoiceFormPdfByDate(requestParameters: InternalV1ApiDownloadCustomerInvoiceFormPdfByDateRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).downloadCustomerInvoiceFormPdfByDate(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiDownloadCustomerInvoiceFormPdfByShiftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public downloadCustomerInvoiceFormPdfByShift(requestParameters: InternalV1ApiDownloadCustomerInvoiceFormPdfByShiftRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).downloadCustomerInvoiceFormPdfByShift(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiDownloadSickPayFormPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public downloadSickPayFormPdf(requestParameters: InternalV1ApiDownloadSickPayFormPdfRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).downloadSickPayFormPdf(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiDownloadSickPayFormPdfByDateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public downloadSickPayFormPdfByDate(requestParameters: InternalV1ApiDownloadSickPayFormPdfByDateRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).downloadSickPayFormPdfByDate(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiDownloadSickPayFormPdfByShiftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public downloadSickPayFormPdfByShift(requestParameters: InternalV1ApiDownloadSickPayFormPdfByShiftRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).downloadSickPayFormPdfByShift(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiDownloadSubcontractorFormDraftPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public downloadSubcontractorFormDraftPdf(requestParameters: InternalV1ApiDownloadSubcontractorFormDraftPdfRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).downloadSubcontractorFormDraftPdf(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiDownloadSubcontractorFormPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public downloadSubcontractorFormPdf(requestParameters: InternalV1ApiDownloadSubcontractorFormPdfRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).downloadSubcontractorFormPdf(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiDownloadSubcontractorFormPdfByDateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public downloadSubcontractorFormPdfByDate(requestParameters: InternalV1ApiDownloadSubcontractorFormPdfByDateRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).downloadSubcontractorFormPdfByDate(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiDownloadSubcontractorFormPdfByShiftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public downloadSubcontractorFormPdfByShift(requestParameters: InternalV1ApiDownloadSubcontractorFormPdfByShiftRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).downloadSubcontractorFormPdfByShift(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiDownloadSubcontractorFormPdfDraftByDateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public downloadSubcontractorFormPdfDraftByDate(requestParameters: InternalV1ApiDownloadSubcontractorFormPdfDraftByDateRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).downloadSubcontractorFormPdfDraftByDate(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiDownloadSubcontractorPdfDraftByShiftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public downloadSubcontractorPdfDraftByShift(requestParameters: InternalV1ApiDownloadSubcontractorPdfDraftByShiftRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).downloadSubcontractorPdfDraftByShift(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiDownloadSubcontractorSelfInvoicingFormPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public downloadSubcontractorSelfInvoicingFormPdf(requestParameters: InternalV1ApiDownloadSubcontractorSelfInvoicingFormPdfRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).downloadSubcontractorSelfInvoicingFormPdf(requestParameters.bookingId, requestParameters.invoiceNumber, requestParameters.invoiceDate, requestParameters.supplierNumber, requestParameters.supplierVatNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiGetBookingTotalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public getBookingTotal(requestParameters: InternalV1ApiGetBookingTotalRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).getBookingTotal(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiGetByBookingIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public getByBookingId(requestParameters: InternalV1ApiGetByBookingIdRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).getByBookingId(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiGetByBookingIdsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public getByBookingIds(requestParameters: InternalV1ApiGetByBookingIdsRequest = {}, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).getByBookingIds(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiGetConfigurableViewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public getConfigurableView(requestParameters: InternalV1ApiGetConfigurableViewRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).getConfigurableView(requestParameters.timereportId, requestParameters.configurableResultViewInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiGetExpensesReceiptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public getExpensesReceipt(requestParameters: InternalV1ApiGetExpensesReceiptRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).getExpensesReceipt(requestParameters.bookingId, requestParameters.dayIndex, requestParameters.expensesInd, requestParameters.index, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiGetFreeTimereportsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public getFreeTimereports(requestParameters: InternalV1ApiGetFreeTimereportsRequest = {}, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).getFreeTimereports(requestParameters.consultantId, requestParameters.week, requestParameters.year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiGetInvoiceStatusForBookingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public getInvoiceStatusForBooking(requestParameters: InternalV1ApiGetInvoiceStatusForBookingRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).getInvoiceStatusForBooking(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiGetPayFormForBookingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public getPayFormForBooking(requestParameters: InternalV1ApiGetPayFormForBookingRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).getPayFormForBooking(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiGetSickPayFormForBookingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public getSickPayFormForBooking(requestParameters: InternalV1ApiGetSickPayFormForBookingRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).getSickPayFormForBooking(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiGetTrackingInternalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public getTrackingInternal(requestParameters: InternalV1ApiGetTrackingInternalRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).getTrackingInternal(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public processMailTask(options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).processMailTask(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiPublishSubcontractorFormDraftToFortnoxRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public publishSubcontractorFormDraftToFortnox(requestParameters: InternalV1ApiPublishSubcontractorFormDraftToFortnoxRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).publishSubcontractorFormDraftToFortnox(requestParameters.bookingId, requestParameters.selfInvoiceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiSaveConsultantPaymentNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public saveConsultantPaymentNote(requestParameters: InternalV1ApiSaveConsultantPaymentNoteRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).saveConsultantPaymentNote(requestParameters.bookingId, requestParameters.noteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiSaveConsultantSickPaymentNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public saveConsultantSickPaymentNote(requestParameters: InternalV1ApiSaveConsultantSickPaymentNoteRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).saveConsultantSickPaymentNote(requestParameters.bookingId, requestParameters.noteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiSaveCustomerInvoiceNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public saveCustomerInvoiceNote(requestParameters: InternalV1ApiSaveCustomerInvoiceNoteRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).saveCustomerInvoiceNote(requestParameters.bookingId, requestParameters.noteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiSaveDayRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public saveDay(requestParameters: InternalV1ApiSaveDayRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).saveDay(requestParameters.timereportId, requestParameters.timereportDayV2Dto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiSaveSubcontractorFormNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public saveSubcontractorFormNote(requestParameters: InternalV1ApiSaveSubcontractorFormNoteRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).saveSubcontractorFormNote(requestParameters.bookingId, requestParameters.noteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiSetAccommodationBenefitTaxRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public setAccommodationBenefitTax(requestParameters: InternalV1ApiSetAccommodationBenefitTaxRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).setAccommodationBenefitTax(requestParameters.bookingId, requestParameters.accommodationInfoDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiSetTimereportDraftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public setTimereportDraft(requestParameters: InternalV1ApiSetTimereportDraftRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).setTimereportDraft(requestParameters.bookingId, requestParameters.approvedBy, requestParameters.approvedId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiSetTravelConfirmationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public setTravelConfirmation(requestParameters: InternalV1ApiSetTravelConfirmationRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).setTravelConfirmation(requestParameters.bookingId, requestParameters.travelInfoDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiSubmittedByConsultantTimereportPipeJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public submittedByConsultantTimereportPipeJob(requestParameters: InternalV1ApiSubmittedByConsultantTimereportPipeJobRequest = {}, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).submittedByConsultantTimereportPipeJob(requestParameters.timereportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public submittedByConsultantTimereportsWatcher(options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).submittedByConsultantTimereportsWatcher(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public testSyncAllGet(options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).testSyncAllGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiUnconfirmedTimereportNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public unconfirmedTimereportNotification(requestParameters: InternalV1ApiUnconfirmedTimereportNotificationRequest = {}, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).unconfirmedTimereportNotification(requestParameters.now, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiUpdateTimereportByBookingIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public updateTimereportByBookingId(requestParameters: InternalV1ApiUpdateTimereportByBookingIdRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).updateTimereportByBookingId(requestParameters.bookingId, requestParameters.timereportInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiValidateConsultantContractOptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public validateConsultantContractOptions(requestParameters: InternalV1ApiValidateConsultantContractOptionsRequest = {}, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).validateConsultantContractOptions(requestParameters.consultantContractPriceRecordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiValidateCustomerContractOptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public validateCustomerContractOptions(requestParameters: InternalV1ApiValidateCustomerContractOptionsRequest = {}, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).validateCustomerContractOptions(requestParameters.customerContractPriceRecordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiViewConsultantPaymentPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public viewConsultantPaymentPdf(requestParameters: InternalV1ApiViewConsultantPaymentPdfRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).viewConsultantPaymentPdf(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiViewCustomerInvoiceFormPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public viewCustomerInvoiceFormPdf(requestParameters: InternalV1ApiViewCustomerInvoiceFormPdfRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).viewCustomerInvoiceFormPdf(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiViewSickPayFormPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public viewSickPayFormPdf(requestParameters: InternalV1ApiViewSickPayFormPdfRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).viewSickPayFormPdf(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiViewSubcontractorFormDraftPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public viewSubcontractorFormDraftPdf(requestParameters: InternalV1ApiViewSubcontractorFormDraftPdfRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).viewSubcontractorFormDraftPdf(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalV1ApiViewSubcontractorFormPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalV1Api
     */
    public viewSubcontractorFormPdf(requestParameters: InternalV1ApiViewSubcontractorFormPdfRequest, options?: RawAxiosRequestConfig) {
        return InternalV1ApiFp(this.configuration).viewSubcontractorFormPdf(requestParameters.bookingId, options).then((request) => request(this.axios, this.basePath));
    }
}

